// extracted by mini-css-extract-plugin
module.exports = {"container":"e_2G","code":"e_3G","codeContent":"e_4G"};